<!-- //
动态table
@author xuyd
@date 2024-5-2
//-->
<template>
  <div style="width: 100%; height: 100%" class="flex-column;">
    <div style="height: calc(100% - 50px);">
      <el-table ref="refSortableDynamicTable"
                v-loading="data.tableLoading"
                :data="data.records"
                stripe
                height="100%"
                size="medium"
                :row-key="rowKey"
                :header-cell-style="this.tableHeader">
        <el-table-column v-if="dragSortable" header-align="left" label="" width="38" align="left">
          <template slot-scope="{row}">
            <span class="dragSortableHandle iconfont iconliebiao" style="cursor: move"></span>
          </template>
        </el-table-column>

        <el-table-column v-if="selection"
                         header-align="center"
                         align="center"
                         width="50"
                         type="selection"/>

        <template v-for="(item, index) in metas">
          <el-table-column v-if="item.prop"
                           header-align="left"
                           align="left"
                           :prop="item.prop"
                           :width="item.width"
                           :min-width="item.minWidth"
                           :show-overflow-tooltip="!!item.showOverflow"
                           :key="index + ''">
            <template slot="header" slot-scope="scope">
              <div class="flex-row flex-valign-center">
                <span v-html="item.label" style="text-align: center;"></span>
                <FunnelRemoteSelect v-if="item.filterable && item.filterComp === 'FunnelRemoteSelect'"
                                    v-model="queryParams[item.prop]"
                                    @change="refresh"/>
                <funnelMultiSelect v-if="item.filterable && item.filterComp === 'FunnelMultiSelect'"
                                   :data-source="$store.getters.dictType[item.dictType]"
                                   v-model="queryParams[item.prop]"
                                   @change="refresh"/>
                <funnelSingleSelect v-if="item.filterable && item.filterComp === 'FunnelSingleSelect'"
                                    :data-source="$store.getters.dictType[item.dictType]"
                                    v-model="queryParams[item.prop]"
                                    @change="refresh"/>
                <SortableIcon v-if="item.sortable" :scope="scope" :sort-params="queryParams" @change="handleSortChange"/>
              </div>
            </template>

            <template slot-scope="{row, column, $index}">

              <el-link v-if="item.dataType === 'link'" @click="handleJump(row, item)" type="primary">
                {{ row[item.prop] }}
              </el-link>

              <dict-tag v-else-if="item.dataType === 'dict'"
                        :dict-type="item.dictType"
                        :value="row[item.prop]"
                        :options="{type: 'tag'}"/>

              <span v-else-if="item.dataType === 'date'">
                {{ $util.parseTime(row[item.prop], '{y}-{m}-{d} {h}:{i}:{s}') }}
              </span>

              <template v-else-if="item.dataType === 'custom'">
                <component v-if="item.customComp" :is="item.customComp" v-model="row[item.prop]" :row-data="row" />
                <custom-slot v-else
                           :row="row"
                           :index="$index"
                           :column="column"
                           :render="item.funcRender"/>
              </template>
              <span v-else>{{ row[item.prop] }}</span>
            </template>
          </el-table-column>
          <el-table-column v-else header-align="left"
                           align="left"
                           :label="item.label"
                           :width="item.width"
                           :min-width="item.minWidth"
                           :fixed="item.fixed"
                           :show-overflow-tooltip="!!item.showOverflow"
                           :key="index">
            <template slot-scope="{row}">
              <slot :row="row" :index="index" :meta="item"/>
            </template>
          </el-table-column>
        </template>
      </el-table>
    </div>
    <!--分页组件-->
    <pagination v-if="!data.hidePagination" :total="data.total" :pageNum.sync="queryParams.pageNum" :pageSize.sync="queryParams.pageSize"
                @pagination="reload"/>
  </div>
</template>

<script>
import Sortable from "sortablejs";

var customSlot = {
  functional: true,
  props: {
    row: Object,
    render: Function,
    index: Number,
    column: {
      type: Object,
      default: null
    }
  },
  render: (h, data) => {
    // console.log('=====render====>'， data)
    const params = {
      row: data.props.row,
      index: data.props.index,
    }
    if (data.props.column) {
      params.column = data.props.column;
      return data.props.render?.(h, params)
    }
  }
}
export default {
  name: 'EditTableComp',
  dictTypes: [],
  components: {customSlot},
  data() {
    return {
      visible: false,
    }
  },
  props: {
    dragSortable: {// 是否可以拖动排序
      type: Boolean,
      default: false
    },
    rowKey: {// 定义的行号，当拖动排序等操作需要
      type: String,
      default: 'id'
    },
    selection: {// 是否可以checkbox
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => {
        return {
          hidePagination: false,
          total: 0,
          records: [],
          tableLoading: false,
        }
      }
    },
    queryParams: {
      type: Object,
      default: () => {
        return {}
      }
    },
    metas: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  computed: {
  },
  mounted() {
    this.$nextTick(() => {
      if (this.dragSortable) {
        this.initSortable();
      }
    });
  },
  methods: {
    initSortable() {
      console.log("初始化排序组件")
      let elTable = this.$refs.refSortableDynamicTable.$el;
      const elTbody = elTable.querySelectorAll(".el-table__body-wrapper > table > tbody")[0];
      // console.log("---------->", elTbody);
      Sortable.create(elTbody, {
        animation: 150, // 动画
        handle: '.dragSortableHandle',
        onEnd: (evt) => {
          console.log(`=====drag index from ${evt.oldIndex} to ${evt.newIndex}`);
          let curRow = this.data.records.splice(evt.oldIndex, 1)[0];
          this.data.records.splice(evt.newIndex,0, curRow);
        },
      })
    },

    /** 排序触发事件 */
    handleSortChange(column) {
      //console.log("----handleSortChange---->"，JS0N.stringify(column))
      if (column.order === 'ascending') {
        this.queryParams.isAsc = true;
        this.queryParams.orderByColumn = column.prop;
      } else if (column.order === 'descending') {
        this.queryParams.isAsc = false;
        this.queryParams.orderByColumn = column.prop;
      } else {
        this.queryParams.isAsc = null;
        this.queryParams.orderByColumn = null;
      }
      this.reload();
    },
    reload() {
      this.$emit("reload");
    },
    refresh() {
      this.queryParams.pageNum = 1;
      this.$emit("reload");
    },
    /**
     * 详情跳转
     * @param row
     * @param item
     */
    handleJump(row, item) {
      if (item.linkType === 'blank') {
        let routeData = this.$router.resolve({name: item.linkUrl, query: {id: row.id}});
        window.open(routeData.href, '_blank');
      } else {
        this.$router.push({name: item.linkUrl, query: {id: row.id}});
      }
    }
  }
}
</script>

<style lang="less" scoped>
</style>
